var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 68,
    viewBox: "0 0 58 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#52C9F4",
    fillOpacity: 0.272
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.418.437l-1.03 12.976a.406.406 0 0 1-.3.34l-.334.09a.41.41 0 0 1-.432-.142L14.798 3.022a.38.38 0 0 1-.047-.36.415.415 0 0 1 .28-.25L23.911.03a.412.412 0 0 1 .363.075c.1.08.156.206.144.332M32.139 66.706l1.03-12.976a.406.406 0 0 1 .3-.34l.334-.09a.41.41 0 0 1 .433.142l7.523 10.679a.38.38 0 0 1 .047.36.415.415 0 0 1-.28.25l-8.88 2.382a.412.412 0 0 1-.363-.075.383.383 0 0 1-.144-.332"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-15 76.872 18.904)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.683,
    height: 33.989,
    y: 5.098,
    fill: "#FFF",
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52C9F4",
    fillOpacity: 0.197,
    d: "M4 10h20v20H4z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    transform: "translate(5.948 13.596)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.497,
    cy: 3.983,
    rx: 4.249,
    ry: 3.983
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.994 16.994c0-3.812-3.804-6.904-8.497-6.904S0 13.182 0 16.994"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#404042",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.119.425v7.647M34.414.425v7.647"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#404042",
    transform: "translate(5.098 12.746)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.497,
    cy: 3.983,
    rx: 4.249,
    ry: 3.983
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.994 16.994c0-3.812-3.804-6.904-8.497-6.904S0 13.182 0 16.994"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#404042",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M22.233 4.249h11.434m3.266 0h9.8A3.267 3.267 0 0 1 50 7.515v13.027M50 31.2v2.45a3.267 3.267 0 0 1-3.267 3.266H4.267A3.267 3.267 0 0 1 1 33.65V7.515A3.267 3.267 0 0 1 4.267 4.25h14.7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.393,
    height: 2.549,
    x: 26.341,
    y: 22.943,
    fill: "#404042",
    fillOpacity: 0.102,
    rx: 1.275
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.393,
    height: 2.549,
    x: 26.341,
    y: 16.994,
    fill: "#404042",
    fillOpacity: 0.102,
    rx: 1.275
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkerIcon);
export default __webpack_public_path__ + "static/media/worker_icon.94ef61e4a4d8297630aa39c35ea57abf.svg";
export { ForwardRef as ReactComponent };